export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Tilauksen aikaraja umpeutui",
      "649f8aefc1c0": "Kierrätys epäonnistui",
      "649f8aefc9c0": "Hanki uusi arvio",
      "TradeIn": "Vaihto-ohjelman prosessi",
      "logistic": "Lataa lähetysetiketti",
      "start": "Aloita prosessi",
      "success": "Olet onnistuneesti vastaanottanut uuden laitteen",
      "qc": "Vanhan laitteen laaduntarkastus",
      "business": "Vanhan laitteesi tarkastus valmistuu kolmen työpäivän kuluessa",
      "completed": "Valmis",
      "successfully": "Onnittelut! Vaihto-ohjelma on suoritettu onnistuneesti",
      "orderInfor": "Tilaustiedot",
      "orderID": "Vaihto-tilauksen tunnus",
      "orderNum": "Uuden laitteen tilaustunnus",
      "createTime": "Luontiaika",
      "brand": "Arvioitu merkki",
      "model": "Arvioitu malli",
      "price": "Vanhan laitteen hinta",
      "bonus": "Bonus",
      "reclaimFailure": "Koska et lähettänyt laitetta 10 päivän kuluessa vastaanottamisesta, kierrätyksen tilaus on vanhentunut ja peruutettu. Jos haluat jatkaa kierrätystä, voit napsauttaa alla olevaa painiketta ja tarkistaa uusimman arvion.",
      "total": "Kokonaishinta",
      "logisticInfo": "Logistiikkatiedot",
      "available": "Ei logistiikkatietoja saatavilla",
      "logisticNum": "Lähetyksen numero",
      "failRey": "Pahoittelemme, että osallistumisesi OnePlusin kierrätysohjelmaan ei onnistunut. Jos haluat kierrättää muita elektronisia tuotteita, voit napsauttaa alla olevaa painiketta saadaksesi nopean arvion!",
      "userRes": "Käyttäjä on jo hylännyt tarjouksen.",
      "successPrice": "Seuraava hinta on ammatillisen tarkastuksen jälkeen määritetty. Jos hyväksyt tämän hinnan, voit jatkaa vaihto-ohjelmaa. Jos hylkäät sen, laite palautetaan sinulle muutaman työpäivän kuluessa.",
      "sure": "Hyväksy",
      "Reject": "Hylkää",
      "congratulation": "Onnittelut! Laatutarkastus ei löytänyt eroja.",
      "finPirce": "Lopullinen hinta",
      "copySuccess": "Kopiointi onnistui",
      "copyfail": "Kopiointi epäonnistui",
      "sureSuccess": "Vahvista onnistunut tapahtuma",
      "submitError": "Lähetys epäonnistui",
      "detectionResult": "Tarkastuksen tulos",
      "Collected": "Tee tilaus",
      "inTransit": "Kuljetuksessa",
      "656g0lj3sav6": "Kierrätysprosessi",
      "656g0lj3cd5a": "Täytä henkilötietosi oikein ja tee tilaus onnistuneesti",
      "656g0lj3dr9a": "Puhelimesi tarkastus valmistuu 48 tunnin kuluessa sen saapumisesta keskukseemme",
      "656g0lj3epal": "Kun tarkastus on valmis, otamme sinuun yhteyttä sähköpostitse ja toimitamme lopullisen tarjouksen",
      "656g0lj3pda2": "Arviosi",
      "656g0lj3ed3d": "Ammatillinen laatutarkastus",
      "656g0lj3esf3": "Kopioi",
      "expertDiscount": "Kampanjakoodi",
      "invalidCode": "Virheellinen koodi",
      "toastTip": "Hyväksyn tietosuojakäytännön ja ehdot",
      "649f8aef26sf": "Vaihto-ohjelman prosessi",
      "checkTitle": "Testaustiedot",
      "basicInformation": "Perustiedot",
      "understand": "Ymmärrän"
    },
    "btnDialog": {
      "64a9shqq2ks0": "Kieltäydy kierrätyksestä",
      "64a9shqq3k00": "Vahvistat, että kieltäydyt kierrätyksestä",
      "64a9shqq3r00": "Peruutus onnistui",
      "64a9shqq3ws0": "Peruutus epäonnistui",
      "sureCancel": "Vahvista peruutus"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Keitä",
      "646u995lv9g0": "olemme?",
      "646u9d5lv9g0": "Danghuan on yritys, joka keskittyy 3C-digitaalisten tuotteiden, kuten puhelinten, tablettien, kannettavien ja älykellojen, kierrätykseen, käsittelyyn ja myyntiin. Tavoitteenamme on tehostaa elektroniikan kierrätystä ja tukea käytettyjen laitteiden markkinoiden kestävää kehitystä. Yrityksellämme on viralliset strategiset kumppanuudet OPPOn, Vivon, OnePlusin, Realmen ja muiden kanssa. Toimimme Intiassa, Thaimaassa, Vietnamissa, Kambodzassa ja nyt myös Euroopassa.",
      "646u995dv9g0": "Maailmanlaajuinen läsnäolomme on tehnyt meistä strategisen kumppanin mobiilioperaattoreille, valmistajille ja tukkureille sekä paikallisesti että kansainvälisesti.",
      "646u99slv9g0": "Teemme yhteistyötä johtavien valmistajien kanssa ja ylläpidämme laajaa varastoa eri hintaluokissa voidaksemme tarjota asiakkaillemme räätälöityjä ratkaisuja ja kilpailukykyisiä hintoja."
    },
    "business": {
      "646v04syvpk0": "Oletko kiinnostunut ostamaan varastostamme?",
      "646v04syxs80": "Danghuan tarjoaa laajan valikoiman puhelimia, tabletteja ja älykelloja eri laatuluokissa vastatakseen monenlaisiin liiketoimintatarpeisiin.",
      "646v04syy6g0": "Ota yhteyttä myynti- ja ostojohtajaamme:",
      "646v04syya80": "Haluan ostaa",
      "646v04syydg0": "Kirjoita nimesi",
      "646v04syyh40": "Kirjoita puhelinnumerosi",
      "646v04syyyw0": "Kirjoita sähköpostiosoitteesi",
      "646v0gsyz1s0": "Maa:",
      "646v04syz1s0": "Valitse vaihtoehto",
      "646v04syz4o0": "Olen lukenut ja hyväksyn",
      "646v04syzkc0": "tietosuojakäytännön",
      "646v04syzok0": "Ota meihin yhteyttä",
      "646v04syzvo0": "Syötä puhelinnumerosi",
      "646v04syzys0": "Syötä sähköpostiosoitteesi",
      "646v04sz01o0": "Syötä kelvollinen sähköposti",
      "646v04sz04g0": "Kirjoita nimesi",
      "646v04sz0740": "Valitse ruutu hyväksyäksesi tietosuojakäytännön",
      "646v04sz0a00": "Lähetys onnistui",
      "646v04sz0cw0": "Lähetys epäonnistui",
      "title1": "Läpinäkyvä laiteluokitus",
      "text1-1": "Auttaaksemme sinua ostopäätöksissä suosittelemme tutustumaan yksityiskohtaiseen luokitusasiakirjaamme, joka kuvaa jokaisen luokan esteettiset ja toiminnalliset standardit, jotta voit tehdä tietoisen valinnan.",
      "title2": "Erinomainen asiakastuki",
      "text2-1": "Ymmärrämme jokaisen asiakkaan yksilölliset tarpeet, minkä vuoksi monikielinen myyntitiimimme tarjoaa henkilökohtaista ja asiantuntevaa palvelua.",
      "title3": "Sitoutuminen kestävään teknologiaan",
      "text3-1": "Olemme sitoutuneet edistämään kestävän teknologian saatavuutta maailmanlaajuisesti ja varmistamaan, että toimintamme luo arvoa kaikille sidosryhmille.",
      "text3-2": "Lisätietoja tai koetilauksen tekemistä varten ota meihin yhteyttä – tiimimme auttaa mielellään ammattitaidolla ja huolenpidolla."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Saat maksun vain neljässä vaiheessa",
      "s1": "Ensimmäinen vaihe",
      "s1t": "Pakkaa laitteesi niin, että se saapuu samassa kunnossa kuin se lähetettiin.",
      "s2": "Toinen vaihe",
      "s2t": "Toimita paketti lähimpään noutopisteeseen.",
      "s3": "Kolmas vaihe",
      "s3t": "Tarkistamme laitteesi ja annamme tarjouksen.",
      "s4": "Neljäs vaihe",
      "s4t": "Saat maksun nopeasti."
    },
    "section3": {
      "646tmse2fbo0": "Älypuhelimet",
      "646tmse2mv00": "Pysy ajan tasalla",
      "section3-text2": "Tabletit",
      "section3-text4": "Älykellot",
      "section3-text5": "Muut",
      "title": "Nopea arviointi",
      "t1": "Valitse laitetyyppi ja aloita arviointi – saat reilun tarjouksen.",
      "t2": "Muutama yksinkertainen vaihe – nauti nopeasta ja helposta kierrätyspalvelustamme!"
    },
    "section6": {
      "646txzpazuc0": "Tietoa Danghuanista",
      "666txzpazuc0": "Yritys, joka on erikoistunut älypuhelinten, tablettien ja muiden digilaitteiden kierrätykseen ja uudelleenkäyttöön. Tarjoamme yksinkertaisen, turvallisen ja tehokkaan prosessin, jonka avulla jokainen asiakas voi helposti kierrättää käytetyn laitteensa.",
      "646txzpb0rk0": "Tiedot",
      "646txzpb0xc0": "Tarjoamme kierrätyspalvelun 12 merkille"
    },
    "section7": {
      "646ns2k5f7k0": "Palvelumme on aina käytettävissä",
      "646ns2k5gmw0": "Asiakaspalvelu: maanantaista perjantaihin klo 9.00 – 18.00 CET (UTC + 1:00) Madrid, Espanja",
      "646ns2k5gs40": "Kirjoita nimesi",
      "646ns2k5gx40": "Kirjoita puhelinnumerosi",
      "646ns2k5img0": "Kirjoita sähköpostiosoitteesi",
      "646ns2k5isw0": "Kirjoita meille viesti ennen yhteydenottoa",
      "646ns2k5iws0": "Ota yhteyttä",
      "646ns2k5j140": "Syötä puhelinnumerosi",
      "646ns2k5j4g0": "Syötä sähköpostiosoitteesi",
      "646ds2k5j4g0": "Sähköposti",
      "646ns2k5j6c0": "Syötä kelvollinen sähköpostiosoite",
      "646ns2k5j8g0": "Ota meihin yhteyttä",
      "646ns2k5jak0": "C.I.F :",
      "646ns2k5jck0": "Osoite",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, Espanja",
      "646ns2k5jgc0": "Kirjoita nimesi",
      "646ns2k5ji40": "Valitse ruutu hyväksyäksesi tietosuojakäytännön",
      "646ns2k5jk00": "Lähetys onnistui",
      "646ns2k5jm80": "Lähetys epäonnistui",
      "646ny1rgz3c0": "Olen lukenut ja hyväksyn ",
      "646ny1rh2k40": "tietosuojakäytännön"
    },
    "successMain": {
      "647qmd42l1s0": "Tilaus vastaanotettu onnistuneesti!",
      "647qmd42mss0": "Kiinnitä huomiota sähköpostiisi lähetettyyn lähetysohjeeseen osoitteesta no-reply@danghuan.eu. Jos et ole saanut sitä, tarkista roskapostikansio tai ota yhteyttä asiakaspalveluun osoitteessa insta360@danghuan.eu.",
      "647qmd42mz80": "Tarjouksemme",
      "647qmd42yeo0": "Vinkkejä ennen lähetystä",
      "orderTime": "Tilauksen aika",
      "text1": "Ilmainen toimitus",
      "text2": "Kiinnitä huomiota sähköpostiisi lähetettyyn lähetysasiakirjaan.",
      "text3": "Tietojen varmuuskopiointi",
      "text4": "Suojataksesi tietosi tee varmuuskopio ja poista kaikki tiedot tai palautta laite alkuasetuksiin.",
      "text5": "Lataa",
      "text6": "Lataa puhelimesi vähintään 1 % ennen lähetystä nopeuttaaksesi tarkastusta.",
      "downloadDec": "Lataa rehellisyysvakuutus."
    },
    "tradeInProcess": {
      "649f8aefats0": "Tilauksen aikaraja umpeutui",
      "649f8aefc1c0": "Kierrätys epäonnistui",
      "649f8aefc9c0": "Hanki uusi arvio",
      "TradeIn": "Vaihto-ohjelman prosessi",
      "logistic": "Lataa lähetysetiketti",
      "start": "Aloita prosessi",
      "success": "Olet onnistuneesti vastaanottanut uuden laitteen",
      "qc": "Vanhan laitteen laaduntarkastus",
      "business": "Vanhan laitteesi tarkastus valmistuu kolmen työpäivän kuluessa",
      "completed": "Valmis",
      "successfully": "Onnittelut! Vaihto-ohjelma on suoritettu onnistuneesti",
      "orderInfor": "Tilaustiedot",
      "orderID": "Kierrätyksen tilausnumero",
      "orderNum": "Uuden laitteen tilaustunnus",
      "createTime": "Luontiaika",
      "brand": "Arvioitu merkki",
      "model": "malli",
      "price": "Vanhan laitteen hinta",
      "bonus": "Bonus",
      "total": "Kokonaishinta",
      "logisticInfo": "Logistiikkatiedot",
      "available": "Ei logistiikkatietoja saatavilla",
      "logisticNum": "Lähetyksen numero",
      "failRey": "Pahoittelemme, että osallistumisesi OnePlusin kierrätysohjelmaan ei onnistunut. Jos haluat kierrättää muita elektronisia tuotteita, voit napsauttaa alla olevaa painiketta saadaksesi nopean arvion!",
      "userRes": "Käyttäjä on jo hylännyt tarjouksen.",
      "successPrice": "Seuraava hinta on ammatillisen tarkastuksen jälkeen määritetty. Jos hyväksyt tämän hinnan, voit jatkaa vaihto-ohjelmaa. Jos hylkäät sen, laite palautetaan sinulle muutaman työpäivän kuluessa.",
      "sure": "Hyväksy",
      "Reject": "Hylkää",
      "congratulation": "Onnittelut! Laatutarkastus ei löytänyt eroja.",
      "finPirce": "Lopullinen hinta",
      "copySuccess": "Kopiointi onnistui",
      "copyfail": "Kopiointi epäonnistui",
      "sureSuccess": "Vahvista onnistunut tapahtuma",
      "submitError": "Lähetys epäonnistui",
      "detectionResult": "Tarkastuksen tulos",
      "Collected": "Vastaanotettu",
      "inTransit": "Kuljetuksessa / Toimituksessa",
      "understand": "Ymmärrän",
      '656g0lj3sf6e': 'Kampanjabonukset tarjotaan ja hallinnoidaan yhteistyömerkkien toimesta. Ne maksetaan erikseen, eivätkä ne ole osa vanhan laitteen arvonmääritystä.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Kieltäydy kierrätyksestä",
      "64a9shqq3k00": "Vahvistat, että kieltäydyt kierrätyksestä",
      "64a9shqq3r00": "Peruutus onnistui",
      "64a9shqq3ws0": "Peruutus epäonnistui",
      "sureCancel": "Vahvista peruutus"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Henkilötiedot",
      "649fhwp9zbo0": "Lataa selkeä kuva paketistasi",
      "649fhwpa1900": "Lataa lähetysetiketti",
      "649fhwpa1l00": "Lataa lähetysetiketti",
      "649fhwpa1tc0": "Toimitus valmis",
      "649fhwpa2100": "Paketin kuva ja rehellisyysilmoitus",
      "649fhwpa2880": "Esimerkki lähetysetiketin kiinnittämisestä",
      "649fhwpa2h80": "Huomautus",
      "649fhwpa2qk0": "Pakkaus: Kääri puhelin kuplamuoviin ja täytä laatikko sanomalehdellä vaurioiden estämiseksi kuljetuksen aikana.",
      "649fhwpa2xs0": "Täytä tyhjät kohdat suojaavalla pehmusteella vahinkojen välttämiseksi.",
      "649fhwpa3fk0": "Logistiikkaetiketti: Ota digitaalinen tai tulostettu etiketti mukaan luovutuspisteeseen; virallinen etiketti tulostetaan siellä.",
      "649fhwpa3v40": "Lähetä käytetty puhelimesi mahdollisimman pian. Jos sitä ei lähetetä 10 päivän kuluessa, tilaus peruutetaan.",
      "649fhwpa42s0": "Noutopisteiden haku",
      "649fhwpa4as0": "Lataa etiketti",
      "649fhwpa4jo0": "Lataa",
      "649fhwpa4ok0": "Etusivu",
      "649fhwpa4to0": "Lähetys onnistui",
      "649fhwpa4yk0": "Onnittelut, lataus onnistui!",
      "649fhwpasf3s": "Huomio",
      "649fhwpaa6f3": "Tulosta ja allekirjoita rehellisyysilmoitus, ota siitä kuva yhdessä vanhan laitteen pakkauksen kanssa ja lataa se."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Sosiaalinen media",
      "646d71qugz40": "Helppo maksu",
      "646u51qugz40": "Logistiikka",
      "646u5dqui780": "Tietosuojakäytäntö",
      "646uddqui780": "Käyttöehdot",
      "646u51qui780": "FAQ"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "Tietoa Danghuanista",
      "646ntjwmn580": "Liiketoiminta",
      "646nt7hwils0": "Ota yhteyttä",
      "646nt7hwipg0": "Osta",
      "646nt7hwis00": "Myy"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Ilmainen arvio"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Syötä malli, jonka haluat myydä",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "Pahoittelemme, mallia ei löydy",
      "confirm": "Vahvista",
      "cancle": "Peruuta",
      "dialogText": "Haluatko varmasti poistaa kaikki historiatiedot?"
    }
  },
  "PCProduct": {
    "empty": "Pahoittelemme, mallia ei löydy"
  },
  "PCBrandTab": {
    "index": "Brändi"
  },
  "PCCategoryTab": {
    "index": "Kategoria"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Tilaa verkossa",
      "646xagqwkuw0": "Ilmainen toimitus",
      "646xagqwmao0": "Testaus",
      "646xagqwmlc0": "Nopea maksu"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Etusivu"
    }
  },
  "router": {
    "selectModel": "Mallit",
    "selectProperty": "Laitteen ongelmat",
    "price": "Arvioitu hinta",
    "priceOrder": "Tee tilaus",
    "orderSuccess": "Tilaus onnistui"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Valitse malli uudelleen",
      "646ymq6ot0k0": "Muistutus",
      "646ymq6pd100": "Ennen lähetystä kirjaudu ulos pilvitilistä",
      "646ymq6pekw0": "näyttölukituksesta ja Apple ID:stä vanhalla laitteella."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Valitse laitteen kunto",
      "647h1f4yr6c0": "Arvioitu hinta",
      "647h1f4yso80": "Arvioitu bonus",
      "text1": "Ilmainen toimitus",
      "text2": "Tarjoamme ilmaisen logistiikka- ja lähetyspalvelun",
      "text3": "Välitön maksu",
      "text4": "Suoritamme maksun 3 työpäivän kuluessa sen jälkeen, kun olemme vastaanottaneet käytetyn laitteesi.",
      "64tve23zt0g0": "Ilmainen toimitus ja myyntipakkaus",
      "64tve23zup00": "Turvallinen datan poisto",
      "64tve23zuy40": "Etkö tyytyväinen? Ilmainen palautus",
      "64tve23zv7g0": "Maksu järjestetään 3 työpäivän kuluessa laitteen vastaanottamisesta",
      "64tve23zvbg0": "Valitse toimitustapasi",
      "64tve23zvf80": "Sinulla on 10 päivää toimittaa puhelimesi.",
      "64tve23zvjc0": "Hanki ilmainen lähetysetiketti ja lähetä puhelimesi.",
      "64tve23zvms0": "Lähetysetiketti lähetetään sähköpostiisi.",
      "64tve23zvqg0": "Huomautus:",
      "64tve23zvyo0": "Älä lähetä puhelinta, jos epäilet akun olevan viallinen tai vahingoittunut litiumakkujen lähetysrajoitusten vuoksi.",
      "64tve23zwak0": "Emme voi palauttaa mukana lähetettyjä tarvikkeita tai pakkauksia.",
      "64tve23zwgs0": "Seuraavat vaiheet puhelimen myymiseen",
      "64tve23zwm80": "Täytä yhteystietosi",
      "64tve23zwt00": "Valmistele puhelimesi lähetystä varten",
      "64tve23zwwk0": "Laitteesi tarkastetaan saapumisen jälkeen. Jos antamasi tiedot ovat virheellisiä, lähetämme sinulle uuden tarjouksen. Voit hyväksyä sen tai saada puhelimesi takaisin ilmaiseksi."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话",
      "646ynp3uehw0": "Syötä IMEI-numero",
      "646ynp3uem40": "Tarkista puhelimesi IMEI näppäilemällä *#06#."
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Näytä tarjous"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Huomio: Puhelimien ja elektroniikan hinta voi laskea jopa 6 %, joten suosittelemme lähettämään paketin mahdollisimman pian.",
      "647hqss760c0": "Olen lukenut ja hyväksyn",
      "647hqss764w0": "tietosuojakäytännön",
      "647hqss76ac0": "Käyttöehdot",
      "647hqss76dg0": "Lähetä",
      "647hqss76gw0": "Yhteensä",
      "text1": "Yhteensä",
      "text2": "Arvioitu hinta",
      "text3": "Arvioitu bonus",
      "dialogTitle": "Huomautus",
      "dialogText": "Napsauta VAHVISTA-painiketta ja tarkista sähköpostisi jatkaaksesi seuraavaan vaiheeseen",
      "dialogBtn": "VAHVISTA"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Tilaustiedot",
      "647kboa06ys0": "Nimi",
      "647kboa0d6v8": "Maakoodi",
      "647kboa078s0": "Puhelin",
      "647kboa07d00": "Osoite",
      "647kboa07jk0": "Maa",
      "647kboa07p80": "Valitse",
      "647kboa08b40": "Postinumero",
      "647kboa08h00": "Kaupunki",
      "647kboa08zc0": "Osoite",
      "647kboa09440": "Pankkitiedot",
      "647kboa096w0": "Sähköpostivahvistus",
      "647kboa09ao0": "Sähköposti",
      "647kboa09dk0": "Vahvistuskoodi",
      "647kboa09u40": "Syötä",
      "647kboa09z80": "Lähetä",
      "647kboa0ak00": "Sähköpostin muotovirhe",
      "647kboa0aog0": "Lähetys onnistui",
      "send": "Lähetetty",
      "submit": "Lähetä",
      "error": "Vahvistuskoodivirhe",
      "64jjt96fg400": "Syötä vahvistuskoodi",
      "64jjt96fki00": "Hanki vahvistuskoodi",
      "idNumber": "Henkilötunnus / ID-numero",
      "declaration": "Rehellisyysilmoitus",
      "download": "lataa",
      "647kboa0idc0": "Henkilötodistus",
      "647kboa0idc1": "(virallinen henkilötunnus, jonka maasi on myöntänyt ja jota käytetään oikeudellisissa, vero- tai hallinnollisissa menettelyissä. Tämä voi olla esimerkiksi DNI, NIE, Verotunnus, Henkilötunnus, CNP tai muu vastaava kansallinen asiakirja asuinmaastasi riippuen.)",
      "647kboa0idc2": "(virallinen henkilötunnus, jonka maasi on myöntänyt ja jota käytetään oikeudellisissa, käytetään tunnistamiseen oikeudellisissa menettelyissä verotuksellisissa tai hallinnollisissa menettelyissä. Tämä voi olla esimerkiksi DNI, NIE, Verotunnus, Henkilötunnus, CNP, tai muu vastaava kansallinen asiakirja, riippuen asuinmaastasi.)",
      "idError": "Virheellinen henkilötunnus",
      "ibanTip": "Käytetään vanhan laitteen maksun vastaanottamiseen.",
      "addreddPlaceholder": "Tämä kenttä tukee enintään 105 merkkiä"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Etusivu",
      "notRecyclable": "Tämän tyyppistä laitetta ei voida kierrättää",
      "IKnow": "Ymmärrän",
      "tips": "Vinkkejä"
    }
  },

  "blog": {
    "blogList": {
      "64wgr171lsk0": "Näyttökerrat",
      "64wgr171nq40": "Ei saatavilla olevaa sisältöä.",
      "64wgr171av65": "Päivämäärä"
    },
    "blogDetail": {
      "64wgr9y5r7s0": "Näyttökerrat",
      "64wgr171wdx9": "Tiedot"
    }
  },

  "cookieNotice": {
    "title": "Evästeilmoitus",
    "description": "Käytämme evästeitä parantaaksemme selauskokemustasi. Jatkamalla tämän sivuston käyttöä hyväksyt",
    "cookiePolicy": "Evästekäytäntö",
    "acceptAll": "Hyväksy kaikki evästeet",
    "acceptNecessary": "Hyväksy vain välttämättömät evästeet",
    "customize": {
      "title": "Valitse evästetyypit, jotka haluat hyväksyä:",
      "necessary": {
        "label": "Välttämättömät evästeet",
        "description": "Nämä evästeet ovat välttämättömiä sivuston toiminnalle eikä niitä voi poistaa käytöstä."
      },
      "analytics": {
        "label": "Analytiikkaevästeet",
        "description": "Nämä evästeet auttavat meitä ymmärtämään, miten vierailijat käyttävät sivustoamme."
      },
      "marketing": {
        "label": "Markkinointievästeet",
        "description": "Nämä evästeet seuraavat käyttäjän toimintaa eri verkkosivustoilla tarjotakseen osuvia mainoksia."
      }
    },
    "save": "Tallenna asetukset",
    "cancel": "Peruuta"
  }
}